import Layers from "slotworks/graphics/layers/layers";
import AbstractStepperControl from "slotworks/smart-ui/controls/abstract/abstract-stepper-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import { formatMoneyAsCurrency } from "slotworks/utils/string-formatters";

export default class AutoplaySingleWinLimitStepperControl extends AbstractStepperControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.stepperComponent.formatFunction = formatMoneyAsCurrency;
        this.stepperComponent.onUpdate.add(this.onStepperUpdated);
    }

    public updateOptions(options: ControlOptions) {
        if (!this.setupData) {

            const limitValues = options.getValidSingleWinLimits();

            if (!limitValues || limitValues.length === 0) {
                this.setVisible(false);
            } else {
                this.setupValues(limitValues, options.singleWinLimit.currentValue);
            }

            this.setupData = true;
        } else {
            this.setSelectedValue(options.singleWinLimit.currentValue);
        }

        this.setValueVisible(!options.customSingleWinLimitSelected);
    }

    private onStepperUpdated = (value: number) => {
        const options = new ControlOptions();
        options.singleWinLimit.currentValue = value;
        options.customSingleWinLimitSelected = false;

        this.onChange.dispatch(options);
    }
}
